<button
  class="link pl-2 animated"
  [class.password-hidden]="!isVisible"
  (click)="toggle()"
  type="button"
  tabindex="-1"
  [attr.aria-label]="'common.togglePasswordVisibility_action' | cxTranslate"
  [attr.aria-pressed]="isVisible"
>
  <ng-template [ngIf]="isVisible" [ngIfElse]="hidden">
    <i nz-icon nzType="eye" nzTheme="outline" class="d-flex text-black-50"></i>
  </ng-template>
  <ng-template #hidden>
    <i nz-icon nzType="eye-invisible" nzTheme="outline" class="d-flex text-black-50"></i>
  </ng-template>
</button>
